import { useEffect, useState } from "react";
import { Settings as SettingsIcon } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import InventoryCategoryManager from "@/components/inventory/InventoryCategoryManager";

/** Iter 160 — Gestión de las opciones del desplegable "¿Cómo nos has conocido?" (antes en la ficha de cliente). */
export default function ReferralSourcesCard({ isAdmin }) {
  const [sources, setSources] = useState([]);
  const [showManager, setShowManager] = useState(false);

  const load = () => {
    api.get("/settings/customer-referral-sources")
      .then((r) => setSources(r.data || []))
      .catch((err) => toast.error(formatApiError(err)));
  };
  useEffect(() => { load(); }, []);

  const active = sources.filter((s) => s.active);
  const inactive = sources.filter((s) => !s.active);

  return (
    <div className="ds-card" data-testid="referral-sources-card">
      <div className="px-4 py-3 border-b border-[#E5E5E0] flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="font-display font-bold text-sm">¿Cómo nos has conocido?</div>
          <p className="text-[11px] text-[#525252] mt-0.5">Opciones del desplegable de la ficha de cliente (origen de captación).</p>
        </div>
        <button
          type="button"
          onClick={() => setShowManager(true)}
          data-testid="referral-sources-manage"
          className="inline-flex items-center gap-1 px-3 py-2 text-xs uppercase tracking-wider border border-[#111110] hover:bg-[#111110] hover:text-white"
        >
          <SettingsIcon size={12} /> Gestionar opciones
        </button>
      </div>
      <div className="p-4 flex flex-wrap gap-2" data-testid="referral-sources-list">
        {active.length === 0 && <span className="text-xs text-[#525252]">Sin opciones activas.</span>}
        {active.map((s) => (
          <span key={s.id} className="px-2.5 py-1 text-xs border border-[#E5E5E0] bg-[#F7F7F4]" data-testid={`referral-source-chip-${s.id}`}>{s.label}</span>
        ))}
        {inactive.map((s) => (
          <span key={s.id} className="px-2.5 py-1 text-xs border border-dashed border-[#E5E5E0] text-[#8A8A82]" title="Inactivo">{s.label}</span>
        ))}
      </div>
      {showManager && (
        <InventoryCategoryManager
          isAdmin={isAdmin}
          onClose={() => setShowManager(false)}
          onSaved={() => { setShowManager(false); load(); }}
          endpoint="/settings/customer-referral-sources"
          title="Gestionar orígenes de captación"
          itemLabelPlural="orígenes"
          itemLabelSingular="origen"
          testidPrefix="referral-source"
          modalTestid="referral-sources-modal"
          saveBtnTestid="referral-sources-save"
          newLabelTestid="referral-source-new-label"
          addTestid="referral-source-add"
          closeTestid="referral-sources-close"
          iterTag="// Iter 160"
        />
      )}
    </div>
  );
}
